export const t = (lang, code) => {
    if (!lang) return 'es';

    const texts = require(`./${lang}`).default;

    if (code && texts && texts[code]) return texts[code];
    else return code;
};